// icon:recycle | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

function IconRecycle(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" height="2.5em" width="2.5em" {...props}>
      <path d="M21.82 15.42l-2.5 4.33c-.49.86-1.4 1.31-2.32 1.25h-2v2l-2.5-4.5L15 14v2h2.82l-2.22-3.85 4.33-2.5 1.8 3.12c.52.77.59 1.8.09 2.65M9.21 3.06h5c.98 0 1.83.57 2.24 1.39l1 1.74 1.73-1-2.64 4.41-5.15.09 1.73-1-1.41-2.45-2.21 3.85-4.34-2.5 1.8-3.12c.41-.83 1.26-1.41 2.25-1.41m-4.16 16.7l-2.5-4.33c-.49-.85-.42-1.87.09-2.64l1-1.73-1.73-1 5.14.08 2.65 4.42-1.73-1L6.56 16H11v5H7.4a2.51 2.51 0 01-2.35-1.24z" />
    </svg>
  );
}

export default IconRecycle;
